export default __webpack_public_path__ + "static/media/languages.f5ec1085.svg";